/**
 * Research Report — section scroll spy
 *
 * Watches each pulp/research-section as it enters the top 25% of the viewport
 * and marks the corresponding .article-menu link with .is-current.
 */
const articleMenu = document.querySelector('.article-menu');
if (articleMenu) {
    const sections = [...document.querySelectorAll('[id^="research-section-"]')];
    const links    = [...articleMenu.querySelectorAll('a')];

    const setActive = (id) => {
        links.forEach(a => {
            a.classList.toggle('is-current', a.getAttribute('href') === `#${id}`);
        });
    };

    // rootMargin fires when a section crosses the upper 25% of the viewport
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                setActive(entry.target.id);
            }
        });
    }, { rootMargin: '0px 0px -75% 0px', threshold: 0 });

    sections.forEach(section => observer.observe(section));

    // Immediate highlight on click before scroll settles
    articleMenu.addEventListener('click', e => {
        const link = e.target.closest('a');
        if (!link) return;
        const id = link.getAttribute('href')?.slice(1);
        if (id) setActive(id);
    });
}
